import React, {useState, useEffect} from 'react'
import {Input} from '@salesforce/design-system-react'

const Footer = ({children}) => {
  return (
    <div className="slds-p-top_small">
      <footer className="slds-modal__footer">
        {children}
      </footer>
    </div>
  )
}

export default Footer
